export const ROLES = {
  MANAGER: { id: '019a83ce-a018-755c-b204-8ae83cf186cf', name: 'Gestor' },
  STUDENT: { id: '019a83ce-be5d-77ab-9e88-6557f0394528', name: 'Estudante' }
}
